var exports = {
  "Qs": "BanMemberModal.module__content___N1Jzd0",
  "Ki": "BanMemberModal.module__video___N1Jzd0",
  "Gf": "BanMemberModal.module__sectionTitle___N1Jzd0",
};

module.exports = exports;
